import React from 'react';
import { InvoiceItem } from '../types';
import { StyledCard, CardTitle } from '../cardStyles';
import { InfoRow, TotalRow, TotalsDivider } from '../style';

interface Props {
  items: InvoiceItem[];
}

const parseBrl = (val: unknown): number => {
  if (typeof val === 'number') return val;
  return Number(String(val || 0).replace(/\./g, '').replace(',', '.') || 0);
};

const formatBrl = (val: number) =>
  val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const TotaisSection: React.FC<Props> = ({ items }) => {
  const totalProdutos = items.reduce((sum, item) => sum + parseBrl(item.vlTotal), 0);
  const totalIcms = items.reduce((sum, item) => sum + parseBrl(item.vlIcms), 0);
  const totalIpi = items.reduce((sum, item) => sum + parseBrl(item.vlIpi), 0);
  const totalNfe = totalProdutos + totalIpi;

  return (
    <StyledCard>
      <CardTitle>Totais</CardTitle>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <InfoRow><span>Produtos</span><strong>{formatBrl(totalProdutos)}</strong></InfoRow>
        <InfoRow><span>ICMS</span><strong>{formatBrl(totalIcms)}</strong></InfoRow>
        <InfoRow><span>IPI</span><strong>{formatBrl(totalIpi)}</strong></InfoRow>
        <TotalsDivider />
        <TotalRow $highlight><span>Total NF-e</span><strong>{formatBrl(totalNfe)}</strong></TotalRow>
      </div>
    </StyledCard>
  );
};

export default TotaisSection;
